module.exports = "https://r.zoocdn.com/_next/static/images/reg-and-signin-2baa1697a83b40ec7a98464741e1cb50.svg";